import { render, staticRenderFns } from "./CourseCard.vue?vue&type=template&id=ddc3bc34&scoped=true"
import script from "./CourseCard.vue?vue&type=script&lang=js"
export * from "./CourseCard.vue?vue&type=script&lang=js"
import style1 from "./CourseCard.vue?vue&type=style&index=1&id=ddc3bc34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddc3bc34",
  null
  
)

export default component.exports